import {
  isGroup,
  type IActivityOccurrenceOrGroup,
  type ITimeOfDay,
} from "@medoma/models/activities";

export function compareTimespans(
  a: [Date, Date, ITimeOfDay] | undefined,
  b: [Date, Date, ITimeOfDay] | undefined,
): number {
  if (!a || !b) {
    return 0;
  }

  // Any time of day -> end of list, let secondary sort decide if both are Any
  if (a[2] === "Any" && b[2] !== "Any") {
    return 1;
  }
  if (b[2] === "Any" && a[2] !== "Any") {
    return -1;
  }

  if (a[0] < b[0]) {
    return -1;
  }
  if (a[0] > b[0]) {
    return 1;
  }
  return 0;
}

export function getTitleFromActivityOccurrenceOrGroup(
  occ: IActivityOccurrenceOrGroup,
): string {
  if (isGroup(occ)) {
    return occ.occurrences[0]?.title ?? "";
  }
  return occ.title;
}
